import React from 'react';
import { FullHeaderLeftSideFullPanelLayout } from 'layouts/fullHeader.LeftSideFullPanel.layout';

const MailBoxes: React.FC = () => {
  return (
    <div id="MailBoxes" data-testid="MailBoxes" className="mail-boxes">
      <FullHeaderLeftSideFullPanelLayout enableHeaderGlobalBar={true}>
        <iframe
          title="Locate 1.0"
          src={`${process.env.REACT_APP_CURRENT_VERSION_URL}/mailboxes?iframe=true`}
          scrolling="no"
          frameBorder="no"
          width="100%"
          height="100%"
        />
      </FullHeaderLeftSideFullPanelLayout>
    </div>
  );
};

export default React.memo(MailBoxes);
